// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';

import LoginPage from './pages/LoginPage';
import POSPage from './pages/POSPage';
import ShiftPage from './pages/ShiftPage';
import DashboardPage from './pages/DashboardPage';
import ProductsPage from './pages/ProductsPage';
import EmployeesPage from './pages/EmployeesPage';
import CategoriesPage from './pages/CategoriesPage';
import StoresPage from './pages/StoresPage';
import StockTransfersPage from './pages/StockTransfersPage';
import OnlineOrdersPage from './pages/OnlineOrdersPage';
import ShopSettingsPage from './pages/ShopSettingsPage';
import CustomersPage from './pages/CustomersPage';
import InventoryManagementPage from './pages/InventoryManagementPage';
import InventoryLogsPage from './pages/InventoryLogsPage';
import CreditCustomersPage from './pages/CreditCustomersPage';

import MainLayout from './components/layout/MainLayout';
import SalesReportPage from './pages/SalesReportPage';
import UsdtWithdrawPage from './pages/UsdtWithdrawPage';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;
  return children;
};

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');
  if (!token) return <Navigate to="/login" replace />;
  try {
    const user = JSON.parse(userStr);
    if (user.role !== 'admin') return <Navigate to="/pos" replace />;
  } catch (err) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

const ManagerRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');
  if (!token) return <Navigate to="/login" replace />;
  try {
    const user = JSON.parse(userStr);
    if (user.role !== 'admin' && user.role !== 'manager') return <Navigate to="/pos" replace />;
  } catch (err) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

const HeadquartersRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');
  if (!token) return <Navigate to="/login" replace />;
  try {
    const user = JSON.parse(userStr);
    if (user.role !== 'admin') return <Navigate to="/pos" replace />;
    if (user.store_type !== 'headquarters') return <Navigate to="/dashboard" replace />;
  } catch (err) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <AppProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/pos" replace />} />

            {/* 所有角色 */}
            <Route path="pos" element={<POSPage />} />
            <Route path="shift" element={<ShiftPage />} />

            {/* 管理员或店长 */}
            <Route path="dashboard" element={<ManagerRoute><DashboardPage /></ManagerRoute>} />
            <Route path="sales-report" element={<ManagerRoute><SalesReportPage /></ManagerRoute>} />
            <Route path="products" element={<ManagerRoute><ProductsPage /></ManagerRoute>} />
            <Route path="inventory" element={<ManagerRoute><InventoryManagementPage /></ManagerRoute>} />
            <Route path="inventory-logs" element={<ManagerRoute><InventoryLogsPage /></ManagerRoute>} />
            <Route path="employees" element={<ManagerRoute><EmployeesPage /></ManagerRoute>} />
            <Route path="stock-transfers" element={<ManagerRoute><StockTransfersPage /></ManagerRoute>} />
            <Route path="online-orders" element={<ManagerRoute><OnlineOrdersPage /></ManagerRoute>} />
            <Route path="customers" element={<ManagerRoute><CustomersPage /></ManagerRoute>} />
            <Route path="credit-customers" element={<ManagerRoute><CreditCustomersPage /></ManagerRoute>} />

            {/* 仅总店管理员 */}
            <Route path="categories" element={<AdminRoute><CategoriesPage /></AdminRoute>} />
            <Route path="stores" element={<HeadquartersRoute><StoresPage /></HeadquartersRoute>} />
            <Route path="shop-settings" element={<HeadquartersRoute><ShopSettingsPage /></HeadquartersRoute>} />

            <Route path="usdt-withdraw" element={<HeadquartersRoute><UsdtWithdrawPage /></HeadquartersRoute>} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AppProvider>
  );
}

export default App;